var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CRow',[_c('CCol',{attrs:{"col":"12","lg":"8","xl":"6"}},[_c('div',{class:this.$func.storyblok2Css(_vm.blok, 'text-default')},[_c('rich-text-renderer',{attrs:{"document":_vm.blok.richtext}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }